import cn from 'classnames';
import PropTypes from 'prop-types';

import css from 'styles/components/icons/fitSurveyValue.scss';

const makeBubbles = ({ value: selectedBubble }) => (
  [1, 2, 3, 4, 5].map(i => (
    <span key={i} className={cn(css.bubble, { [css.selected]: i === selectedBubble })} />
  ))
);

const FitSurveyValue = props => (
  <div className={css.container}>
    <div className={css.arm} />
    <div className={css.bubbles}>{makeBubbles(props)}</div>
  </div>
);

FitSurveyValue.propTypes = {
  value: PropTypes.number.isRequired
};

export default FitSurveyValue;
